
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/wallet",
      function () {
        return require("private-next-pages/app/wallet/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/wallet"])
      });
    }
  